import type { Domain } from '../protocol/types';

/** Dopo quanto tempo la slice di un dominio è considerata "non aggiornata" (null = mai). */
export const STALE_AFTER_MS: Record<Domain, number | null> = {
  site: null,
  weather: 4_500_000, // lettura ogni 30 minuti: una lettura mancata è ancora tollerata
  energy: 120_000,
  health: 120_000,
  facts: 7_200_000,
  comfort: 180_000,
  mood: null,
  occupancy: 120_000,
  indoor: 180_000,
  coffee: null,
};

/** Slice assente ⇒ vecchia. Se c'è `measuredAt` (lettura del contatore) conta quello, non `updatedAt`. */
export function isStale(
  domain: Domain,
  slice: { updatedAt: number; measuredAt?: number } | undefined,
  now: number,
): boolean {
  if (!slice) return true;
  const limit = STALE_AFTER_MS[domain];
  if (limit === null) return false;
  return now - (slice.measuredAt ?? slice.updatedAt) > limit;
}

/** Se non arriva più nulla (nemmeno i pong) per tanto, ogni dato è considerato vecchio: anche quelli a evento. */
export const SILENCE_STALE_MS = 300_000;
